import React from 'react'
import { Alert, Divider } from 'antd'
import { useTranslation } from 'react-i18next'
import GoogleSheets from '../../../../../components/GoogleSheets/GoogleSheets'

const BudgetGoogleSheets = () => {
  const { t } = useTranslation()
  return (
    <>
      <GoogleSheets type="budget" />
      <Divider />
      <Alert description={t('budgetingImportPage:info-text')} />
    </>
  )
}

export default BudgetGoogleSheets
